import type { Project } from '@shared/types'
import { HttpApiClient } from '../HttpApiClient'

/**
 * API client for the Finance variant. Routes all requests through
 * /finance/api instead of /api so the server can enforce variant: 'fin'
 * server-side and prepare a distinct /finance path for RBAC gating.
 *
 * keepAlive is overridden because the base implementation does
 * this.base.replace('/api', '') which would produce /finance/healthz
 * rather than /healthz.
 *
 * listProjects is overridden to filter out non-Finance dashboards so the
 * Finance variant only surfaces projects created with variant === 'fin'.
 */
export class FinHttpApiClient extends HttpApiClient {
  constructor() {
    super('/finance/api')
  }

  override keepAlive(): void {
    void fetch('/healthz', { credentials: 'include' }).catch(() => {})
  }

  override async listProjects(options?: { mineOnly?: boolean }): Promise<Project[]> {
    const all = await super.listProjects(options)
    return all.filter((p) => p.profile?.variant === 'fin')
  }

  override async getAdminDashboards(): Promise<Project[]> {
    const all = await super.getAdminDashboards()
    return all.filter((p) => p.profile?.variant === 'fin')
  }
}
